"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Definition = void 0;
const types_1 = require("@refinitiv-data/types");
const lodash_functions_1 = require("../../../util/lodash-functions");
const default_session_1 = require("../../../session/default-session");
const streaming_chain_1 = require("./streaming-chain");
function Definition(params) {
    let name;
    let parameters;
    if ((0, lodash_functions_1.isPlainObject)(params)) {
        const _a = params, { name: universeName } = _a, restParams = __rest(_a, ["name"]);
        name = universeName;
        parameters = restParams;
    }
    else {
        name = params;
        parameters = undefined;
    }
    return {
        getStream(session = (0, default_session_1.getDefault)(), api = types_1.DEFAULT_OMM_STREAMING_CONNECTION_NAME) {
            return new streaming_chain_1.StreamingChainImpl(session, name, Object.assign(Object.assign({}, parameters), { api }));
        },
    };
}
exports.Definition = Definition;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGVmaW5pdGlvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9jb250ZW50L3ByaWNpbmcvY2hhaW4vZGVmaW5pdGlvbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7OztBQUFBLGlEQUFrSDtBQUVsSCxxRUFBK0Q7QUFDL0Qsc0VBQThEO0FBQzlELHVEQUF1RDtBQUl2RCxTQUFnQixVQUFVLENBQUMsTUFBcUM7SUFDNUQsSUFBSSxJQUFZLENBQUM7SUFDakIsSUFBSSxVQUFtRCxDQUFDO0lBQ3hELElBQUksSUFBQSxnQ0FBYSxFQUFDLE1BQU0sQ0FBQyxFQUFFLENBQUM7UUFDeEIsTUFBTSxLQUF3QyxNQUE4QixFQUF0RSxFQUFFLElBQUksRUFBRSxZQUFZLE9BQWtELEVBQTdDLFVBQVUsY0FBbkMsUUFBcUMsQ0FBaUMsQ0FBQztRQUM3RSxJQUFJLEdBQUcsWUFBWSxDQUFDO1FBQ3BCLFVBQVUsR0FBRyxVQUFVLENBQUM7SUFDNUIsQ0FBQztTQUFNLENBQUM7UUFDSixJQUFJLEdBQUcsTUFBZ0IsQ0FBQztRQUN4QixVQUFVLEdBQUcsU0FBUyxDQUFDO0lBQzNCLENBQUM7SUFFRCxPQUFPO1FBQ0gsU0FBUyxDQUFDLFVBQW1CLElBQUEsNEJBQVUsR0FBRSxFQUFFLE1BQWMsNkNBQXFDO1lBQzFGLE9BQU8sSUFBSSxvQ0FBa0IsQ0FBQyxPQUFPLEVBQUUsSUFBSSxrQ0FBTyxVQUFVLEtBQUUsR0FBRyxJQUFHLENBQUM7UUFDekUsQ0FBQztLQUNKLENBQUM7QUFDTixDQUFDO0FBakJELGdDQWlCQyJ9